// import { supabase } from "./gitDbConnection";

// export const getLatestGitActivity = async () => {
//   const { data, error } = await supabase
//     .from("events")
//     .select("*")
//     .order("id", { ascending: false })  

//   return { data, error };
// };
import { supabase } from "./gitDbConnection";

export const getLatestGitActivity = async () => {
  const { data, error } = await supabase
    .from("events")
    .select("*")
    .order("timestamp", { ascending: false });

  return { data, error };
};